/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetNftRewardResponse } from './GetNftRewardResponse';
import {
    GetNftRewardResponseFromJSON,
    GetNftRewardResponseFromJSONTyped,
    GetNftRewardResponseToJSON,
    GetNftRewardResponseToJSONTyped,
} from './GetNftRewardResponse';

/**
 * 
 * @export
 * @interface DevourLootboxNftRewardBatchItem
 */
export interface DevourLootboxNftRewardBatchItem {
    /**
     * 
     * @type {string}
     * @memberof DevourLootboxNftRewardBatchItem
     */
    trackerId: string;
    /**
     * 
     * @type {GetNftRewardResponse}
     * @memberof DevourLootboxNftRewardBatchItem
     */
    reward: GetNftRewardResponse;
}

/**
 * Check if a given object implements the DevourLootboxNftRewardBatchItem interface.
 */
export function instanceOfDevourLootboxNftRewardBatchItem(value: object): value is DevourLootboxNftRewardBatchItem {
    if (!('trackerId' in value) || value['trackerId'] === undefined) return false;
    if (!('reward' in value) || value['reward'] === undefined) return false;
    return true;
}

export function DevourLootboxNftRewardBatchItemFromJSON(json: any): DevourLootboxNftRewardBatchItem {
    return DevourLootboxNftRewardBatchItemFromJSONTyped(json, false);
}

export function DevourLootboxNftRewardBatchItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevourLootboxNftRewardBatchItem {
    if (json == null) {
        return json;
    }
    return {
        
        'trackerId': json['trackerId'],
        'reward': GetNftRewardResponseFromJSON(json['reward']),
    };
}

export function DevourLootboxNftRewardBatchItemToJSON(json: any): DevourLootboxNftRewardBatchItem {
    return DevourLootboxNftRewardBatchItemToJSONTyped(json, false);
}

export function DevourLootboxNftRewardBatchItemToJSONTyped(value?: DevourLootboxNftRewardBatchItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trackerId': value['trackerId'],
        'reward': GetNftRewardResponseToJSON(value['reward']),
    };
}

